import { useEffect } from 'react';
import { useGetOrgsQuery } from '../services/orgApi';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setSelectedOrgId } from '../store/orgSlice';
import { Dropdown } from './ui';

export const OrganizationSwitcher = ({
  className = 'w-40',
}: {
  className?: string;
}) => {
  const { data: orgs, isLoading } = useGetOrgsQuery();
  const dispatch = useAppDispatch();
  const selectedOrgId = useAppSelector(state => state.org.selectedOrgId);

  // Auto-select first org if none selected and orgs available
  useEffect(() => {
    if (!selectedOrgId && orgs && orgs.length > 0) {
      dispatch(setSelectedOrgId(orgs[0].id));
    }
  }, [orgs, selectedOrgId, dispatch]);

  if (isLoading) {
    return <div className={`h-9 animate-pulse rounded ${className}`} />;
  }

  const orgOptions =
    orgs?.map(org => ({
      label: org.name,
      value: org.id,
    })) || [];

  // Always render the dropdown, even if empty, to show location
  // If empty, it will just show placeholder and have no options
  return (
    <div className={className}>
      <Dropdown
        items={orgOptions}
        value={selectedOrgId || ''}
        placeholder={orgOptions.length === 0 ? 'No Orgs' : 'Org'}
        onSelect={value => dispatch(setSelectedOrgId(value))}
        size="sm"
        fullWidth
        disabled={orgOptions.length === 0}
      />
    </div>
  );
};
